<template>
  <div class="row" v-if="!isLoading">
    <div class="col-12">
      <img class="mt-3" :srcset="`${logo} 3x`" />
      <p class="mt-4 mb-3">
        {{ $t('SETTINGS.TEXT.ADD_YOUR_GOOGLE_ANALYTICS_CODE') }}
      </p>
      <div class="mb-4 d-flex align-items-center">
        <font-awesome-icon
          class="text-primary mr-2"
          :icon="['far', 'info-circle']"
        />
        <a
          href="https://support.google.com/analytics/answer/9539598?hl=en"
          target="_blank"
        >
          {{ $t('SETTINGS.LINK.NEED_HELP_FINDING_YOUR_GOOGLE_ANALYTICS_CODE') }}
        </a>
      </div>
    </div>
    <div class="col-12">
      <HMTextInput
        :label="$t('SETTINGS.LABEL.GOOGLE_ANALYTICS_CODE')"
        placeholder="UA-XXXXXXXXX-X"
        v-model="googleAnalyticsCode"
      />
    </div>
    <!--      <hr class="mx-3 w-100" />-->
    <div class="col-12 form-group">
      <HMButton color="primary" @click="update" :loading="inProgress">
        {{ $t('SETTINGS.BUTTON.UPDATE') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'GoogleAnalyticsIntegration',
  data() {
    return {
      logo: '/assets/images/integrations/google-analytics.png',
      isLoading: true,
      inProgress: false,
      googleAnalyticsCode: null,
    };
  },
  methods: {
    async update() {
      this.inProgress = true;
      try {
        await this.$store.dispatch(
          'setting/updateGoogleAnalyticsCode',
          this.googleAnalyticsCode
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'SETTINGS.NOTIFICATIONS.GOOGLE_ANALYTICS_CODE_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    remove() {
      this.googleAnalyticsCode = null;
      this.update();
    },
  },
  async mounted() {
    this.googleAnalyticsCode = await this.$store.dispatch(
      'setting/getGoogleAnalyticsCode'
    );
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
